






import { Component, Vue } from "vue-property-decorator";
import PTOAdminView from "@/components/payroll/policies/pto/PTOAdminView.vue";

@Component({
	components: { PTOAdminView }
})
export default class AdminPoliciesPTO extends Vue {
}
